import React from 'react';
import Services from '../components/Services';
import SEO from '../components/SEO';

const ServicesPage = () => {
  return (
    <>
      <SEO
        title="Hizmetlerimiz"
        description="LYSEP CORPORATION hizmetleri: Otomotiv çözümleri, araç gizli özellik açma, OBD Screen, web siteleri, QR menü sistemleri, masaüstü uygulamalar ve yazılım geliştirme hizmetleri."
        keywords="otomotiv yazılımları, araç gizli özellik açma, OBD screen, web geliştirme, QR menü, masaüstü uygulama, yazılım hizmetleri, teknoloji çözümleri"
        path="/services"
      />
      <Services />
    </>
  );
};

export default ServicesPage;

